import BillingInformation from './BillingInformation'

export default BillingInformation
